/**
 * Editorial course-preview video, Bunny Stream embed.
 * Kept as a single component so both Landing + Course pages stay in sync.
 */
export function VideoPreview({ variant = "light", eyebrow = "A Glimpse Inside The Studio", headline, italicWord = "Studio", tail = "in Motion.", body }) {
  const isDark = variant === "dark";
  return (
    <section
      data-testid="course-preview-video"
      className={`${isDark ? "bg-[#0A0A0A] text-[#FAFAFA]" : "bg-[#F2F0EB] text-[#0A0A0A]"} border-y border-black/10`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14 items-center">
        <div className="md:col-span-4">
          <p className="overline mb-6" style={isDark ? { color: "#D4AF37" } : {}}>
            <span className="gold-line mr-3" />
            {eyebrow}
          </p>
          <h2 className="font-serif-display font-light text-4xl md:text-5xl leading-[1.05]">
            {headline || (<>The <span className="font-serif-italic italic text-[#D4AF37]">{italicWord}</span><br />{tail}</>)}
          </h2>
          {body && (
            <p className={`mt-8 leading-relaxed max-w-md ${isDark ? "text-[#E5E5E5]" : "text-[#3a3a3a]"}`}>
              {body}
            </p>
          )}
        </div>
        <div className="md:col-span-8">
          <div className="relative overflow-hidden shadow-[0_30px_80px_-40px_rgba(0,0,0,0.4)]" style={{ paddingTop: "56.25%" }}>
            <iframe
              data-testid="bunny-stream-iframe"
              title="Course Preview"
              src="https://player.mediadelivery.net/embed/729227/6a8a0d94-5748-45b0-bebf-270b3110e57e?autoplay=false&loop=false&muted=false&preload=true&responsive=true"
              loading="lazy"
              style={{ border: 0, position: "absolute", top: 0, left: 0, height: "100%", width: "100%" }}
              allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;fullscreen;"
              allowFullScreen
            />
          </div>
        </div>
      </div>
    </section>
  );
}
